<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>
      {{ "WALLET.TITLE" | translate }}
    </ion-title>
    <ion-buttons slot="start">
      <ion-back-button
        [defaultHref]="flavor === 'vendors' ? '/main' : '/'"
        [text]="'COMMON.BACK' | translate"
      ></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="flex flex-col items-center">
    <div class="w-full max-w-[650px]">
      <div
        class="from-primary mx-4 mt-4 flex min-h-[150px] flex-col rounded-3xl bg-gradient-to-br to-purple-700 ps-6 pe-6 py-8 dark:from-blue-700 dark:to-purple-800"
      >
        <ion-text class="text-white/70">
          {{ "WALLET.BALANCE" | translate }}
        </ion-text>
        <div class="flex items-center">
          <ion-text class="mt-3 text-3xl font-bold text-white">
            {{ walletStore.walletBalance() | quarterFloor | vxCurrency }}
          </ion-text>
          <ion-button fill="clear" id="click-trigger" class="ms-auto !me-0" shape="round">
            <ion-icon name="info-circle" slot="icon-only" class="text-white/70"></ion-icon>
          </ion-button>
          <ion-popover
            trigger="click-trigger"
            triggerAction="click"
            mode="ios"
            class="rounded-dialog"
            side="right"
            [showBackdrop]="false"
            keepContentsMounted="false"
          >
            <ng-template>
              <ion-content>
                <div class="flex flex-col px-4 py-2">
                  <ion-text class="text-medium">
                    {{ "WALLET.HELD_BALANCE" | translate }}
                  </ion-text>
                  <ion-text class="mt-2">
                    {{ walletStore.heldBalance() | quarterFloor | vxCurrency }}
                  </ion-text>
                </div>
              </ion-content>
            </ng-template>
          </ion-popover>
        </div>

        <ion-button class="mt-6 !h-6 rounded-full bg-white/10" fill="clear" (click)="paymentMethodSelector.start()">
          <ion-text class="text-white/80">
            {{ "WALLET.TOP_UP" | translate }}
          </ion-text>
          <ion-icon slot="end" name="top-up" class="text-white/70"></ion-icon>
        </ion-button>
      </div>

      @switch (walletStore.walletTransactionsListState().type) {
        @case ("loading") {
          <mtjr-loading />
        }
        @case ("error") {
          <mtjr-error [failure]="walletStore.walletTransactionsFailure()" />
        }
        @case ("success") {
          <div class="px-4 pt-4">
            <div class=",mb-2 mx-2">
              <ion-text class="text-medium">
                {{ "WALLET.TRANSACTIONS" | translate }}
              </ion-text>
            </div>
            <ion-list class="!mb-10">
              @for (transaction of walletStore.walletTransactions(); track $index) {
                <ion-card class="!m-0 !mt-2">
                  <ion-item class="!px-0 !py-2" color="transparent" lines="none">
                    @if (transaction.type === "capture") {
                      <div slot="start" class="bg-danger/10 flex items-center justify-center rounded-xl p-2">
                        <ion-icon name="money-out" class="text-danger text-2xl"></ion-icon>
                      </div>
                    } @else if (transaction.type === "refund") {
                      <div slot="start" class="bg-primary/10 flex items-center justify-center rounded-xl p-2">
                        <ion-icon name="refund" class="text-primary text-2xl"></ion-icon>
                      </div>
                    } @else if (transaction.type === "hold") {
                      <div slot="start" class="bg-warning/10 flex items-center justify-center rounded-xl p-2">
                        <ion-icon name="hold" class="text-warning text-2xl"></ion-icon>
                      </div>
                    } @else if (transaction.type === "release") {
                      <div slot="start" class="bg-indigo-500/10 flex items-center justify-center rounded-xl p-2">
                        <ion-icon name="release" class="text-indigo-500 text-2xl"></ion-icon>
                      </div>
                    } @else {
                      <div slot="start" class="bg-success/10 flex items-center justify-center rounded-xl p-2">
                        <ion-icon name="money-in" class="text-success text-2xl"></ion-icon>
                      </div>
                    }
                    <div class="flex w-full flex-col">
                      <div class="flex flex-col items-start">
                        <div class="flex items-center">
                          <ion-text>
                            {{ "ENUMS.WalletTransactionType." + transaction.type | translate }}
                          </ion-text>
                        </div>
                        <ion-text class="text-medium mt-1 text-sm">
                          <!-- {{ transaction.createdAt | date: "dd-MM-yyyy HH:mm" }} -->
                          {{ transaction.createdAt | date: "yyyy-MM-dd HH:mm" }}
                        </ion-text>
                      </div>
                    </div>
                    <ion-text
                      slot="end"
                      [ngClass]="{
                        'text-danger': transaction.type === 'capture',
                        'text-success': transaction.type === 'topUp',
                      }"
                    >
                      {{ transaction.amount | quarterFloor | vxCurrency }}
                    </ion-text>
                  </ion-item>
                  <div class="bg-medium/10 h-[2px]"></div>
                  <ion-item lines="none">
                    <div slot="start" class="size-10"></div>
                    <ion-text slot="start" class="text-sm">
                      <span class="text-medium">{{ "COMMON.STATUS" | translate }}</span>
                      <span class="mx-1">:</span>
                      <span
                        [ngClass]="{
                          'text-danger/60': transaction.status === 'failed',
                          'text-success/60': transaction.status === 'completed',
                          'text-warning/60': transaction.status === 'pending',
                        }"
                      >
                        {{ "ENUMS.WalletTransactionStatus." + transaction.status | translate }}
                      </span>
                    </ion-text>
                    @if (transaction.topUpPaymentMethod; as paymentMethod) {
                      <ion-text class="text-medium text-sm">
                        {{ "ENUMS.TopUpPaymentMethod." + paymentMethod | translate }}
                      </ion-text>
                    }
                    @if (transaction.usdAmount; as usdAmount) {
                      <ion-text slot="end" class="text-medium ms-2 text-sm">
                        {{ usdAmount.div(100).toNumber() | currency }}
                      </ion-text>
                    }
                    @if (transaction.type === "capture" && transaction.orderId; as orderId) {
                      <ion-button fill="clear" slot="end" routerLink="/orders/{{ orderId }}">
                        {{ "ORDERS.ORDER_DETAILS" | translate }}
                        <ion-icon name="orders" slot="end" />
                      </ion-button>
                    }
                  </ion-item>
                </ion-card>
              } @empty {
                <div class="flex w-full flex-col items-center justify-center">
                  <mtjr-dynamic-img
                    src="/assets/no_products.svg"
                    darkSrc="/assets/no_products_dark.svg"
                    class="size-[180px] opacity-80 dark:opacity-70"
                  />
                  <p class="text-medium/70 mt-5 text-center">
                    {{ "WALLET.NO_TRANSACTIONS" | translate }}
                    <br />
                  </p>
                </div>
              }
            </ion-list>
            <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
              <ion-infinite-scroll-content></ion-infinite-scroll-content>
            </ion-infinite-scroll>
          </div>
        }
      }
    </div>
  </div>
</ion-content>
<mtjr-payment-method-selector
  [paymentIntentType]="'walletTopUp'"
  [modalTitle]="'WALLET.TOP_UP' | translate"
  [submitButtonLabel]="'WALLET.TOP_UP' | translate"
  #paymentMethodSelector
/>
